export default {
    lists: {
        quickLinkPersonal: '~siteCollection/Lists/riQuickLinksPersonal',
        quickLinkGeneral: '~siteCollection/Lists/riQuickLinksGeneral',
        quickLinkIcons: '~siteCollection/Lists/riQuickLinksIcons',
        quickLinkColors: '~siteCollection/Lists/riQuickLinksColors',
        taskLists: '~siteCollection/Lists/riTaskLists',
        searchSuggestionsList: '~siteCollection/Lists/riSearchSuggestions',
    },
    fields: {
        assignedTo: 'AssignedTo',
        created: 'Created',
        workflowStatus: 'Status',
        url: 'URL',
        taskListColumns: 'riTaskListColumns',
        taskListTopic: 'riTaskListTopic',
        taskListTopicByField: 'riTaskListTopicByField',
        taskListUrl: 'riTaskListUrl',
        title: 'Title',
        topicIsMandatory: 'riTopicIsMandatory',
    },
};
